<template>
  <div style="margin: 10px; height: 600px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="客户编号"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input
          v-model="options.khbh"
          placeholder="客户编号"
          v-bind:disabled="khbh_dis"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="客户名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.khmc" placeholder="客户名称"></v-input>
      </v-form-item>
      <v-form-item
        label="地区/分组"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-button icon="plus" @click.prevent="zj()"></v-button>
        <v-button icon="minus" @click.prevent="sc()"></v-button>
        <vxe-grid
          maxWidth:50
          v-bind="xGridOptions"
          size="mini"
          ref="xGrid"
          border
          show-overflow
          :data="tableData2"
          :edit-config="{
            trigger: 'click',
            mode: 'row',
            activeMethod: activeCellMethod,
          }"
          @edit-disabled="editDisabledEvent"
        >
          <template v-slot:khdq="{ row }">
            <v-cascader v-model="row.khdq" :data="khdq_options"></v-cascader>
          </template>
        </vxe-grid>
      </v-form-item>
      <v-form-item
        label="客户简称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.khjc" placeholder="客户简称"></v-input>
      </v-form-item>
      <v-form-item
        label="本部/客户"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-radio-group
          v-model="options.sybm"
          :data="sybm_options"
        ></v-radio-group>
      </v-form-item>
      <v-form-item
        label="客户地址"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.khdz" placeholder="客户地址"></v-input>
      </v-form-item>
      <v-form-item
        label="社会信用代码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.shxydm" placeholder="社会信用代码"></v-input>
      </v-form-item>
      <v-form-item
        label="联系电话"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.khdh" placeholder="联系电话"></v-input>
      </v-form-item>
      <v-form-item
        label="联系人"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.lxr" placeholder="联系人"></v-input>
      </v-form-item>
      <v-form-item
        label="联系人电话"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.lxdh" placeholder="联系人电话"></v-input>
      </v-form-item>
      <v-form-item
        label="邮箱地址"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.yxdz" placeholder="邮箱地址"></v-input>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xy_bz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  khbh: "",
  khmc: "",
  khjc: "",
  khdz: "",
  shxydm: "",
  khdh: "",
  lxr: "",
  lxdh: "",
  yxdz: "",
  sybm: "2",
  xy_bz: true,
  fz: [],
  khdq: [],
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options,
      tableData2: [],
      fz: 0,
      khbh_dis: false,
      khdq_options: [],
      sybm_options: [
        { text: "本部", value: "1" },
        { text: "客户", value: "2" },
      ],
      xGridOptions: {
        resizable: false,
        height: 200,
        headerAlign: "center",
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 50,
            align: "center",
          },
          {
            field: "khdq",
            title: "地区",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "khdq",
            },
            // editRender: {
            //   name: "$select",
            //   options: [],
            // },
          },
          {
            field: "khfz",
            title: "分组",
            align: "center",
            editRender: { name: "input" },
          },
          {
            field: "kqgz",
            title: "考勤",
            align: "center",
            editRender: {
              name: "$select",
              options: [],
            },
          },
        ],
      },
    };
  },
  created() {
    this.init_khdq();
    this.init_kqgz();
    if (this.$route.query.khbh) {
      this.init();
      this.khbh_dis = true;
    } else {
      this.zj();
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/khwh/get-khwh-first?khbh=" + this.$route.query.khbh)
        .then((res) => {
          this.options = res.data;
          if (res.data.xy_bz == 1) {
            this.options.xy_bz = true;
          } else {
            this.options.xy_bz = false;
          }
        });
      this.$axios
        .get(
          "api/system/khwh/get-khwh-firstdqfz?khbh=" + this.$route.query.khbh
        )
        .then((res) => {
          setTimeout(() => {
            res.data.map((item) => {
              this.tableData2.push({
                id: item.id,
                khdq: item.bddq.replace("{", "").replace("}", "").split(","),
                khfz: item.fzmc,
                kqgz: item.kqgz,
              });
            });
          }, 500);
        });
    },
    init_khdq: function () {
      // this.$axios.get("api/system/khwh/get-khwh-dqdm").then((res) => {
      //   const column = this.$refs.xGrid.getColumnByField("khdq");
      //   column.editRender.options = res.data.map((item) => {
      //     return { value: item.dm, label: item.mc };
      //   });
      // });
      this.$axios.get("api/system/khwh/del-khwh-dqtree").then((res) => {
        if (res.data.code == 200) {
          let self = this;
          self.khdq_options = res.data.data;
        } else {
          this.$message["error"](res.data.message);
        }
      });
    },
    init_kqgz: function () {
      this.$axios.get("api/system/khwh/get-khwh-kqgz").then((res) => {
        const column = this.$refs.xGrid.getColumnByField("kqgz");
        column.editRender.options = res.data.map((item) => {
          return { value: item.gzdm, label: item.gzmc };
        });
      });
    },
    save() {
      if (!this.options.khbh.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入客户编号！");
        return;
      }
      if (!this.options.khmc.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入客户名称！");
        return;
      }
      if (!this.options.khjc.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入客户简称！");
        return;
      }
      if(this.options.shxydm){
        if(this.options.shxydm.length != 18 && this.options.shxydm.length != 15 && this.options.shxydm.length != 20){
          this.$message["error"]("请正确输入15位,18位或20位社会信用代码！");
          return;
        }
      }
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if(this.options.yxdz){
          if(!reg.test(this.options.yxdz)){
            this.$message["error"]("邮箱格式错误！");
            return;
          }
      }
      if (this.options.xy_bz) {
        this.options.xy_bz = "1";
      } else {
        this.options.xy_bz = "0";
      }
      let dqflag = 0;
      this.$refs.xGrid.getTableData().tableData.forEach((el) => {
        if (el.khdq.length == 0) {
          dqflag = 1;
        }
      });
      if (dqflag == 1) {
        this.$message["error"]("请输入客户地区！");
        return;
      }
      this.options.fz = this.$refs.xGrid.getTableData().tableData;
      if (this.$route.query.khbh) {
        this.$axios
          .post("api/system/khwh/update-khwh-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      } else {
        this.$axios
          .get("api/system/khwh/get-khwh-khbh?khbh=" + this.options.khbh)
          .then((res) => {
            if (res.data.message == 1) {
              this.$axios
                .post("api/system/khwh/set-khwh-first", this.options)
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message["success"](res.data.message);
                    xadmin.close();
                    xadmin.father_reload();
                  } else {
                    this.$message["error"](res.data.message);
                  }
                });
            } else {
              this.$message["error"]("客户编号已存在请重新输入！");
              return;
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
    },
    zj() {
      this.tableData2.push({
        id: "",
        khdq: [],
        khfz: "",
        kqgz: "请选择考勤",
      });
      // this.$refs.xGrid.getScroll().scrollTop += 100000;
      // console.log(this.$refs.xGrid.getScroll().scrollHeight);
    },
    sc() {
      if (this.tableData2.length == 1) {
        this.$message["error"]("最少保留一条地区分组");
      } else {
        this.tableData2.pop();
        this.$message["success"]("已删除！");
      }
    },
    activeCellMethod({ column, columnIndex }) {
      if (columnIndex === 0) {
        return false;
      }
      return true;
    },
    editDisabledEvent({ row, column }) {
      alert("禁止编辑");
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/khwhadd.vue